/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // const domain = window.location.hostname
  // const swHost = domain === 'amccrs-evr.verdedata.ro' ? process.env.BASE_URL : 'https://amccrs-evr.verdedata.ro/'
  const swHost = process.env.BASE_URL

  // console.log(swHost)
  // const swHost = domain === 'lifturi-s6.dragos.club' ? process.env.BASE_URL : 'https://lifturi-s6.dragos.club/'

  register(`${swHost}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered, Verde-Share AMCCRS-EVR!')
    },
    cached () {
      console.log('Content has been cached for offline use!')
    },
    updatefound () {
      console.log('New content is downloading!')
    },
    updated (registration) {
      console.log('register worker installing...')
      console.log('New content is available; please refresh. Service worker should do that by itself.')
      let worker = registration.waiting
      worker.postMessage({ action: 'skipWaiting' })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode!')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

var refreshing
navigator.serviceWorker.addEventListener('controllerchange', function () {
  console.log('controllerchange')
  if (!refreshing && window.confirm('Doresti sa incarci noua versiune a aplicatiei?')) {
    if (refreshing) return
    window.location.reload()
    refreshing = true
  }
})
